// Admin panel is served from a dedicated hostname on the same CloudFront
// distribution/Amplify build as the normal app (see aws-tf-regulify's
// frontend.tf) — the React app branches its UI tree by hostname client-side
// rather than needing a separate deployment.
export function isAdminHost() {
  return window.location.hostname.startsWith("admin.");
}
